var _path, _circle, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindshieldInside(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 24,
    viewBox: "0 0 47 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4633 2.27527C0.989808 1.45795 1.35829 1.26932 2.04209 1.26934L44.8151 1.01786C46.1199 0.866967 45.7796 1.70943 45.4464 2.14953L39.7118 12.5861C39.1867 13.5417 38.5109 13.8644 38.2387 13.9064L9.35503 14.2836C8.40802 14.2836 7.98713 14.2836 7.61885 13.9064L1.4633 2.27527Z",
    fill: "#E75300",
    stroke: "white",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9751,
    cy: 16.7056,
    r: 6.35989,
    fill: "#E75300",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9747 20.4275L29.993 15.7204L37.9563 15.7204L33.9747 20.4275Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2287 15.5012L35.9082 15.7931L36.0177 16.5959L39.3382 17.3621C39.5133 16.8075 39.3382 15.8904 39.2287 15.5012Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6854 15.538L32.0059 15.8299L31.8964 16.6326L28.5759 17.3989C28.4008 16.8443 28.5759 15.9272 28.6854 15.538Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6602 22.0331L33.4264 19.5519H34.5941L35.2873 22.0331C34.7619 22.325 33.317 22.1547 32.6602 22.0331Z",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8991 2.67284V1.84253H24.2502V2.27953V2.67284M22.8991 2.67284L20.0222 2.84764C19.7752 2.87678 19.2812 3.03992 19.2812 3.45945L19.1941 4.28976C19.1505 4.47913 19.2202 4.85787 19.8479 4.85787H26.8655C27.1707 4.82873 27.4758 4.79032 27.4758 4.28976C27.4758 3.80905 27.3595 3.40118 27.345 3.32835C27.3305 3.16811 27.1271 2.93504 26.7348 2.84764C26.1152 2.70961 25.1396 2.71747 24.2502 2.67284M22.8991 2.67284C23.0932 2.66105 23.9346 2.657 24.2502 2.67284",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindshieldInside);
export default __webpack_public_path__ + "static/media/windshield-inside.125f2b74032161eded8b6b94bc08bc21.svg";
export { ForwardRef as ReactComponent };